import { IconName, colors, getFillRule, icons } from '@aloft/toolkit-sui';
import { G, Path, Svg } from '@react-pdf/renderer';

type Props = {
  icon: IconName;
};

export const Icon = ({ icon }: Props) => {
  const { paths, viewBox = '0 0 24 24' } = icons[icon];
  const pathNodes = paths.map((path, idx) => <Path key={idx} d={path} />);

  return (
    <Svg width="24" height="24" viewBox={viewBox}>
      <G fill={colors.textPrimary} fillRule={getFillRule(icon)}>
        {pathNodes}
      </G>
    </Svg>
  );
};
